export default __webpack_public_path__ + "static/pagination-5d309ab5c4cb5cc3e429f7df41be6779.png";